module.exports = __webpack_public_path__ + "icono.png?9e3be12662bfb11eee9f11bbbbf487d0";